import { Type } from "class-transformer";
import { TaskFileCategoryEnum } from "@altertec_gparn/lib";
import { FileDto } from "../file/file.dto";
import { TaskDto } from "@/core/features/tasks/task.dto";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { TechnicalReportSectionDto } from "@/core/features/technical-report-sections/technical-report-section.dto";

export class TaskFileDto extends BaseEntityDto {
  @Type(() => TaskDto)
  task: TaskDto;
  taskId: string;

  @Type(() => FileDto)
  file: FileDto;

  isPublic: boolean;

  @Type(() => TechnicalReportSectionDto)
  technicalReportSection?: TechnicalReportSectionDto;
  technicalReportSectionId?: string;

  category?: TaskFileCategoryEnum | null;
}
